import { ITherapist, IUser } from "../../types/types";
import { AppImage } from "../appMedia";
import therapistStyles from "./therapist.module.css";
import { charMax, tabletWidth } from "../../utils/constants";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useLazyGetTherapistDatesQuery } from "../../services/api/therapists.api";
import { useActions } from "../../services/hooks/useActions";
import { tWithKeyAttr as t } from "../../i18nHelper";


interface ITherapistProps {
  therapist: IUser;
  onClose: () => void;
  // setShowCalendar?: (a: boolean) => void;
}
function Therapist({ therapist, onClose }: ITherapistProps) {
  const [full, setFull] = useState(false);
  const navigate = useNavigate();
  const { setDates } = useActions();

  const isTablet = useMediaQuery(tabletWidth);

  const [fetchDates, { data, isError }] = useLazyGetTherapistDatesQuery();

  return (
    <section className={therapistStyles.therapist}>
      <div className={therapistStyles.infoContainer}>
        <article className={therapistStyles.card}>
          <AppImage
            src={therapist.avatar}
            alt={therapist.name}
            className={therapistStyles.card__avatar}
          />
          <p className={therapistStyles.card__name}>{therapist.fullName}</p>
          <p className={therapistStyles.card__status}>{therapist.status}</p>
          <p className={therapistStyles.card__tag}>{t('MY_THERAPIST')}</p>
          {/* <ul className={therapistStyles.card__connectionBar}>
            <li
              title={t("CHAT")}
              onClick={() => navigate("/chat")}
              className={`${therapistStyles.card__connectionBarLi} ${therapistStyles.card__connectionBarLi_chat} ${therapistStyles.card__connectionBarLi_active}`}
            />
            <li
              title={t("PHONE")}
              className={`${therapistStyles.card__connectionBarLi} ${therapistStyles.card__connectionBarLi_phone}`}
            />
            <li
              title={t("VIDEO")}
              className={`${therapistStyles.card__connectionBarLi} ${therapistStyles.card__connectionBarLi_video} ${therapistStyles.card__connectionBarLi}`}
            />
          </ul> */}
          {/* <button
            className={therapistStyles.card__btn}
            onClick={() => {
              fetchDates(therapist.id);
              setDates();
              // setShowCalendar?(true):console.log("here");
            }}
          >
            {t('SET_A_MEETING')}</button> */}
        </article>
        <div className={therapistStyles.therapist__info}>
          {therapist.video &&
            <video
              className={therapistStyles.therapist__video}
              src={therapist.video}
              controls={true}
            />}
          <div className={therapistStyles.therapist__about}>

            <h3 className={`${therapist.about ? therapistStyles.therapist__aboutTitle : therapistStyles.noAboutInformation}`}>
              {therapist.about ? t('KTSAT_ALAY') : t("NO_DETAILS_ABOUT")}
            </h3>

            <p
              className={`${therapistStyles.therapist__text} ${full ? therapistStyles.therapist__text_full : ""
                }`}
            >
              {therapist.about}
            </p>
            {therapist.about && therapist.about.length > charMax && (
              <button
                className={therapistStyles.therapist__moreBtn}
                onClick={() => setFull(!full)}
              >
                {full ? t('READ_LESS') : t('READ_MORE')}
              </button>
            )}
          </div>
        </div>
      </div>
      <button className={therapistStyles.therapist__closeBtn} onClick={onClose}>
        {t('RETURN')}</button>
    </section>
  );
}

export default Therapist;
